import React, { useContext } from 'react';
import WindowWrapper from '../context/WindowWrapper';
import LongLogo from '../../assets/img/logo_lang.png';
import PlacesAutoComplete from '../forms/PlacesAutoComplete';
import PrimaryButton from '../buttons/PrimaryButton';
import { TrackingContext } from '../context/Tracking';

const PreFilterWindow = ({ style, close, className, content, ...props }) => {
  const [placesValue, setPlacesValue] = React.useState('');
  const { t } = useContext(TrackingContext);
  return (
    <>
      <WindowWrapper
        maxWidth={500}
        maxHeight={400}
        className={'window-wrapper nice-scroll ' + (className || '')}
        style={{ padding: 40, ...style }}
        close={close}
      >
        <img src={LongLogo} width={200} style={{ marginTop: -70 }} />
        <h5>Wo willst du suchen?</h5>
        <p>Finde heraus, wie es anderen Mediziner:innen in Deutschland ergeht...</p>
        <PlacesAutoComplete
          name='pre_filter_places'
          setCenterAndZoomIn={(x, y) => { props.setCenterAndZoomIn(x, y); setPlacesValue(old => { t('action', 'pre_filter_by_city', old); return old; }); close(); }}
          map={props.mapInstance}
          mapApi={props.mapApi}
          setValue={setPlacesValue}
          value={placesValue}
          style={{ marginBottom: 0 }}
        />
        <br />
        <PrimaryButton style={{ float: 'right' }} onClick={close}>Überspringen</PrimaryButton>
      </WindowWrapper>
    </>
  );
};

export default PreFilterWindow;
